export const INAV_VARIANTS = {
  CONTROL: 'control',
  INAV_VAR_A: 'variantA',
};

export const GLOBAL_HEADER_NAME = 'axp-global-header';
